<div class="container-fluid g-0 mb-5">
  <div class="row g-0 m-0 d-flex pt-5 pb-5 ps-5 align-items-center">
    <h2 class="title">{{ "PROFILE" | translate }}</h2>
    <h6 class="subtitle">{{ "PROFILE_SUBTITLE" | translate }}</h6>
  </div>
  <div class="row-md-4 g-0 justify-content-center d-flex">
    <div class="col-md-4 item d-flex flex-column p-4">
      <div class="row g-0 pt-4">
        <div class="col">
          @if (user.image !== "/") {
          <img src="data:image/jpeg;base64,{{ user.image }}" alt="User" class="circle-img" />
          } @else {
          <div class="col-md-1 g-0 p-0 d-flex justify-content-center align-items-center member-picture">
            <span class="item-title">{{ firstName![0] }}</span>
          </div>
          }
        </div>
        <div class="col-auto d-flex justify-content-end align-items-center mt-2">
          <span class="role ps-2 pe-2 pt-1 pb-1">{{ user.role }}</span>
        </div>
      </div>
      <form #crudform="ngForm" (ngSubmit)="saveUser()">
        <div class="row g-0 pt-4">
          @if (
          isFirstNameInputShown &&
          authService.isAuthorized([PermissionsEnum.Personalize_modify])
          ) {
          <div class="overlay-light" (click)="toggleInput()"></div>
          <div class="col">
            <span class="row g-0 user-label">{{ "NAME" | translate }}</span>
            <div class="row g-0 user-input d-flex justify-content-between">
              <div class="col pe-2 pt-2">
                <input id="firstName" type="text" class="p-2" [(ngModel)]="user.firstName" #firstName="ngModel"
                  name="firstName" required />
              </div>
              <button type="submit" [disabled]="crudform.invalid" class="col-auto add d-flex align-items-center mt-2">
                {{ "SAVE" | translate }}
              </button>
            </div>
            @if (crudform.submitted && firstName.invalid) {
            <div class="validation-error">
              {{ "FIRSTNAME" | translate }}
              {{ "DEVICESETUP_ISREQUIRED" | translate }}.
            </div>
            } @else if (!firstName.valid) {
            <div class="validation-instruction">
              {{ "TEAMSETUP_FIRSTNAMEDESC" | translate }}
            </div>
            }
            <div class="horizontal-line pt-4"></div>
          </div>
          } @else {
          <div class="col">
            <span class="row g-0 user-label">{{ "NAME" | translate }}</span>
            <span class="row g-0 user-data pt-2">{{ user.firstName }}</span>
          </div>
          <div class="col d-flex justify-content-end align-items-center">
            <img alt="Right arrow" class="cursor-pointer" src="/assets/account/right.svg"
              (click)="toggleInput('firstName')" />
          </div>
          }
        </div>
        <div class="row g-0 pt-4">
          @if (
          isMiddleNameInputShown &&
          authService.isAuthorized([PermissionsEnum.Personalize_modify])
          ) {
          <div class="overlay-light" (click)="toggleInput()"></div>
          <div class="col">
            <span class="row g-0 user-label">{{
              "MIDDLENAME" | translate
              }}</span>
            <div class="row g-0 user-input d-flex justify-content-between">
              <div class="col pe-2 pt-2">
                <input type="text" class="p-2" [(ngModel)]="user.middleName" name="middleName" id="middleName"
                  #middleName="ngModel" />
              </div>
              <button type="submit" [disabled]="crudform.invalid" class="col-auto add d-flex align-items-center mt-2">
                {{ "SAVE" | translate }}
              </button>
            </div>
            @if (middleName.value == null || middleName.value === "") {
            <div class="validation-instruction">
              {{ "TEAMSETUP_MIDDLENAMEDESC" | translate }}
            </div>
            }
            <div class="horizontal-line pt-4"></div>
          </div>
          } @else {
          <div class="col">
            <span class="row g-0 user-label">{{
              "MIDDLENAME" | translate
              }}</span>
            <span class="row g-0 user-data pt-2">{{
              user.middleName ? user.middleName : "/"
              }}</span>
          </div>
          <div class="col d-flex justify-content-end align-items-center">
            <img alt="Right arrow" class="cursor-pointer" src="/assets/account/right.svg"
              (click)="toggleInput('middleName')" />
          </div>
          }
        </div>
        <div class="row g-0 pt-4">
          @if (
          isLastNameInputShown &&
          authService.isAuthorized([PermissionsEnum.Personalize_modify])
          ) {
          <div class="overlay-light" (click)="toggleInput()"></div>
          <div class="col">
            <span class="row g-0 user-label">{{
              "LASTNAME" | translate
              }}</span>
            <div class="row g-0 user-input d-flex justify-content-between">
              <div class="col pe-2 pt-2">
                <input type="text" class="p-2" [(ngModel)]="user.lastName" name="lastName" id="lastName"
                  #lastName="ngModel" required />
              </div>
              <button type="submit" [disabled]="crudform.invalid" class="col-auto add d-flex align-items-center mt-2">
                {{ "SAVE" | translate }}
              </button>
            </div>
            @if (crudform.submitted && lastName.invalid) {
            <div class="validation-error">
              {{ "LASTNAME" | translate }}
              {{ "DEVICESETUP_ISREQUIRED" | translate }}.
            </div>
            } @else if (!lastName.valid) {
            <div class="validation-instruction">
              {{ "TEAMSETUP_LASTNAMEDESC" | translate }}
            </div>
            }
            <div class="horizontal-line pt-4"></div>
          </div>
          } @else {
          <div class="col">
            <span class="row g-0 user-label">{{
              "LASTNAME" | translate
              }}</span>
            <span class="row g-0 user-data pt-2">{{ user.lastName }}</span>
          </div>
          <div class="col d-flex justify-content-end align-items-center">
            <img alt="Right arrow" class="cursor-pointer" src="/assets/account/right.svg"
              (click)="toggleInput('lastName')" />
          </div>
          }
        </div>
        <div class="row g-0 pt-4">
          @if (
          isPhoneNumberInputShown &&
          authService.isAuthorized([PermissionsEnum.Personalize_modify])
          ) {
          <div class="overlay-light" (click)="toggleInput()"></div>
          <div class="col">
            <span class="row g-0 user-label">{{
              "PHONENUMBER" | translate
              }}</span>
            <div class="row g-0 user-input d-flex justify-content-between">
              <div class="col pe-2 pt-2">
                <input type="text" class="p-2" [(ngModel)]="user.phoneNumber" name="phoneNumber" id="phoneNumber"
                  #phoneNumber="ngModel" pattern="^\+?[0-9]+$" required />
              </div>
              <button type="submit" [disabled]="crudform.invalid" class="col-auto add d-flex align-items-center mt-2">
                {{ "SAVE" | translate }}
              </button>
              @if (crudform.submitted && phoneNumber.invalid) {
              <div class="validation-error">
                {{ "PHONENUMBER" | translate
                }}{{ "DEVICESETUP_ISREQUIRED" | translate }}
              </div>
              } @else if (!phoneNumber || phoneNumber.value === "") {
              <div class="validation-instruction">
                {{ "TEAMSETUP_PHONENUMBERDESC" | translate }}
              </div>
              } @else if (
              phoneNumber.invalid && phoneNumber.errors?.["pattern"]
              ) {
              <div class="validation-error">
                {{ "TEAMSETUP_PHONENUMBERERROR" | translate }}
              </div>
              }
            </div>
            <div class="horizontal-line pt-4"></div>
          </div>
          } @else {
          <div class="col">
            <span class="row g-0 user-label">{{
              "PHONENUMBER" | translate
              }}</span>
            <span class="row g-0 user-data pt-2">{{ user.phoneNumber }}</span>
          </div>
          <div class="col d-flex justify-content-end align-items-center">
            <img alt="Right arrow" class="cursor-pointer" src="/assets/account/right.svg"
              (click)="toggleInput('phoneNumber')" />
          </div>
          }
        </div>
        <div class="row g-0 pt-4">
          @if (
          isAddressInputShown &&
          authService.isAuthorized([PermissionsEnum.Personalize_modify])
          ) {
          <div class="overlay-light" (click)="toggleInput()"></div>
          <div class="col">
            <span class="row g-0 user-label">{{
              "DEVICESETUP_DEVICEADDRESS" | translate
              }}</span>
            <div class="row g-0 user-input d-flex justify-content-between">
              <div class="col pe-2 pt-2">
                <input type="text" class="p-2" [(ngModel)]="user.address" name="address" id="address"
                  #address="ngModel" />
              </div>
              <button type="submit" class="col-auto add d-flex align-items-center mt-2">
                {{ "SAVE" | translate }}
              </button>
            </div>
            @if (address.value == null || address.value === "") {
            <div class="validation-instruction">
              {{ "TEAMSETUP_EMAILADDRESSDESC" | translate }}
              {{ "OPTIONAL" | translate }}
            </div>
            }
          </div>
          } @else {
          <div class="col">
            <span class="row g-0 user-label">{{
              "DEVICESETUP_DEVICEADDRESS" | translate
              }}</span>
            <span class="row g-0 user-data pt-2">{{
              user.address ? user.address : "/"
              }}</span>
          </div>
          <div class="col d-flex justify-content-end align-items-center">
            <img alt="Right arrow" class="cursor-pointer" src="/assets/account/right.svg"
              (click)="toggleInput('address')" />
          </div>
          }
        </div>
      </form>
    </div>
  </div>
</div>